import "../../../StyleSheet/MainComponent/User/SignaturePopup.scss";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignaturePad from "react-signature-canvas";
import {
  SetTheSetUserSignError,
  SetTheEditFunction,
  Files,
  SetSignaturePops,
  SetTheCountNumbersNam,
  setTheSingatureFilename,
  SetChangedUrl,
  setThecreateEmploSigAction, /// created the employee , as onboring flow
  gettheApproveRequestInmnagaerList, 
  settheFullPresentUrl ,///--- to Crud url
  setThepresentUrlOfSignature , //---backend passingURl
  setThePresentUrlsSended ,/// bool value
} from "../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { PresentUrl } from "../../../text/apidata";
import { store } from "../../../Redux/Store";
import { getLoaderAction } from "../../../Redux/Loader";
import { getLoaderAction2 } from "../../../Redux/Loader2";

const SignaturePopup = (props) => {
  const {
    show,
    setShow,
    setUserSignError,
    fileName,
    setCountingNum,
    img,
    EditId,
  } = props;
  // console.log(fileName, "lkmb ");
  const [ImageUrl, setImageUrl] = useState(null);
  const dispatch = useDispatch();
  const signatureCanvas = useRef({});
  const [mangerlistoption, settheManagerlist] = useState(); 
  const[searchInManager , setSearchMangerList] = useState("");
  const [Signed , setSigned] = useState(false)
  const[manager, setmangerlist] = useState({
    manager_list:""
  })
   const [MangerErro , setmanagerError] = useState("")
const [singatureTested , setsignatureTested] = useState(false)
 const Navigate = useNavigate();


  const state = useSelector((state) => state);
  const formdatas = new FormData();
  const Clear = () => {
    setSigned(false)
    signatureCanvas.current.clear();
  };

 useEffect(()=>{
   if(state.signaturepad.SignaturePadNumbers == 0){ 
   const payload = {
    return_type:"before_assign",
    // user:"",
    // page_size:"",
    // page:"1",
    search:searchInManager,
    client:state.NumberCounts?.BranchObjectJobInfoFieldAgent?.value
   }
  dispatch(gettheApproveRequestInmnagaerList(payload))
   }
 },[searchInManager])

  // console.log(state.managerapproverequestdata.managerRequestDataHold ,"managerRequestDataHold");
  
 
 useEffect(() => {
if(state.signaturepad.SignaturePadNumbers == 0){ 
  if (state.managerapproverequestdata.managerRequestDataHold != undefined) {
    let branchlist = [];
    state.managerapproverequestdata.managerRequestDataHold.forEach((element) => {
        branchlist.push({
          value: element.id,
          label: element.first_name.toUpperCase(),
        })
    });
    settheManagerlist(branchlist);

  }
}
}, [state.managerapproverequestdata.managerRequestDataHold ,searchInManager]);


  const SaveSignature = () => {
     var a = 0;
     if( state.signaturepad.SignaturePadNumbers == 0 && manager.manager_list == ""){
      setmanagerError("*Please Select Rm")
       a = 1;
     }

    //  setUserSignError("");
    dispatch(SetTheSetUserSignError(""));
    dispatch(SetTheEditFunction(true));

    var base64String = signatureCanvas.current
      .getTrimmedCanvas()
      .toDataURL("image/png");

    // Remove data URL prefix if present
    base64String = base64String.split(",")[1];

    // Replace URL-safe characters if necessary
    base64String = base64String.replace(/-/g, "+").replace(/_/g, "/");
    const binaryData = atob(base64String);

    // Create a Blob from the binary data
    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: "image/png" });
    const count = Math.random();
    // Create a File from the Blob
  const randomNumber = Math.floor(Math.random() * 100000);

const FileBlob = new File([blob], randomNumber + "ada", {
  type: "image/png",
});

         setTimeout(() => {
          setImageUrl(FileBlob);
         }, 10);
    dispatch(SetChangedUrl(2));

console.log(ImageUrl ,"asodiuasoidu ImageUrl",FileBlob);


    if (FileBlob != null) {


      const generateRandomNumber = (digits = 12) => {
  const min = 10 ** (digits - 1);
  const max = 10 ** digits;
  return Math.floor(min + Math.random() * (max - min));
};

      
      const createPresentData = (FileBlob) => {
        const randomNumber = generateRandomNumber();
        const formattedFilename = `onboarding/user_sign/user_sign${randomNumber}.${FileBlob.type.split('/')[1]}`; // Use the file's extension
        const Presentdata = {
          multiple_files: [
            {
              filename: formattedFilename,
              file_type: FileBlob.type,
            },
          ],
        };
      
        return Presentdata;
      };
var SignatureURL  = []
 let BackendUrls 

      const Presentdata = createPresentData(FileBlob);
if(Signed == true && singatureTested  == false) { 
   dispatch(getLoaderAction(true))
      axios( {
        url:PresentUrl,
        method:'post',
        data: Presentdata,
        headers: {
          Authorization:
            "Bearer " + store.getState().users.UserData.session.token,
        },
      })
      .then((response) => {
        dispatch(getLoaderAction(false))

        const uploadedFiles = response.data.data; 
         
        const newUrls = uploadedFiles.map(url => ({
          url: url, 
          type: FileBlob.type,
          putfiles:FileBlob

        }));
        setsignatureTested(true)

         console.log(newUrls ,"newUrls");
         
         dispatch(setThePresentUrlsSended(true))
        dispatch(settheFullPresentUrl(newUrls));
        dispatch(setThepresentUrlOfSignature(String(response.data.data).split("?")[0]));

        BackendUrls = String(response.data.data).split("?")[0]
        
      })
      // .catch((error) => {
      //   dispatch(getLoaderAction(false))

      //   console.error('Error uploading files:', error);
      // });
       .catch((error) => {
        dispatch(getLoaderAction(false))
    console.error("Error uploading files:", error);
  })
  .finally(() => {
    dispatch(getLoaderAction(false)); // loader is closed in one place cleanly
  });

      
    }
      dispatch(Files(FileBlob));

      var fileNAME = FileBlob;
      var reader = new FileReader();
      reader.onloadend = function () {
        //setImg(reader.result);
        console.log(reader, "results");
      };
      //reader.readAsDataURL(fileNAME)
      if (
        reader.readAsDataURL(fileNAME) != null &&
        reader.readAsDataURL(fileNAME) != undefined &&
        reader.readAsDataURL(fileNAME).result != undefined
      ) {
        // dispatch(setTheSingatureFilename(reader.readAsDataURL(fileNAME).result))
        console.log(reader.readAsDataURL(fileNAME).result, "re123123sults");

      }
      dispatch(
        setTheSingatureFilename(
          signatureCanvas.current.getTrimmedCanvas().toDataURL("image/png")
        )
      );
      if ( Signed && state.signaturepad.SignaturePadNumbers == 1) {
        dispatch(SetSignaturePops(false));
      } 
      else if ( 
        Signed &&
        // a == 0 && 
        manager?.manager_list != "" &&
        state.signaturepad.SignaturePadNumbers == 0) {
          const fetchUploadFiles = async () => {
                // dispatch(getLoaderAction2(true));
            await Promise.all(state.signaturepad.PresentFullURL.map(async (item) => {
              try {
                const response = await fetch(item.url, {
                  method: 'PUT',
                  headers: {
                    'Content-Type': item.type,
                    "x-amz-acl": "public-read"
                  },
                  body: FileBlob,
                });

                dispatch(setThePresentUrlsSended(false))

                const payload = {
                formdatas: {
                create_employee:true ,
                sign:state.signaturepad.PresentURL,
                manager_id:manager.manager_list
              },
              id: state.BasicFormCreated.user_ID,
              Funcations: () => {
                if(state.SideBarFiles.SideBarFile == "Onboarding"){ 
                            Navigate("/fieldagent");
                }
                else { 
                            Navigate("/myonboarding");
                }
      
              },
            };
            formdatas.append("create_employee", true);
            formdatas.append("sign", FileBlob);
            formdatas.append("manager_id", manager.manager_list);
    
    
            dispatch(setThecreateEmploSigAction(payload));
    
            dispatch(SetSignaturePops(false));



              } catch (error) {
                console.error('Error uploading files:', error);
              }
              finally {
    // ✅ SINGLE source of truth
    dispatch(getLoaderAction2(false));
  }

     

            }));
          }
      
      

          fetchUploadFiles()



      }
       else if(a == 1 && state.signaturepad.SignaturePadNumbers == 0){
        toast.error(` Plaese Select the RM `, {
          position: toast.POSITION.TOP_RIGHT,
        });
       }
       if(Signed == false 
        // && state.signaturepad.SignaturePadNumbers == 0
      ){
        toast.error("Signature is required before proceeding.", {
          position: toast.POSITION.TOP_RIGHT,
        });      
       }
      
    }

    if (!state.signaturepad.SignaturePopups) {
      // dispatch(Files(""));
      dispatch(SetTheCountNumbersNam(""));
    }

  };
   const HandleMangerList =(e)=>{
    setmangerlist({
      ...manager,
      manager_list:e.value

    })
   }
    const HandleChangesINput=(e)=>{
      setSearchMangerList(e)

    }
    console.log(state.signaturepad.SignaturePadNumbers ,"state.signaturepad.SignaturePadNumbers",Signed ,

      Signed &&
        // a == 0 && 
        manager?.manager_list != "" &&
        state.signaturepad.SignaturePadNumbers == 0
    );
    
 
  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div 
          className="RolePopups_Signature"
          //  className="RolePopups"
          >
            <div className="asds">
              <div class="InnerSingaturePoups">

              {state.signaturepad.SignaturePadNumbers == 0 ? 
<>
<div className="col-12" style={{marginBottom:"19px"}}>
               <label for="validationCustom01" class="form-label">
                       Select RM
                          <span style={{ color: "red" }}>*</span>
                        </label>
                       <Select
                           className="Selects "
                          styles={{ position: "relative", top: "60px" }}
                            onChange={(e)=>{
                              HandleMangerList(e);
                              setmanagerError("")
                            }}
                          options={mangerlistoption}
                          onInputChange={HandleChangesINput}
                     
                        />
                      </div>
                      <p className="Error RMFilter">{MangerErro}</p>
</>
                     : null }


                <div
                  className={`SignaturePopup               
                  `}
                >
                  <SignaturePad
                    ref={signatureCanvas}
                    onEnd={(e)=>{
                      setSigned(true)
                    }}
                    canvasProps={{
                      className: "signatureCanvas",

                      style: {border:"4px solid #eee"},
                    }}
                  />
                </div>

                <div className="Entried-Fields">
                  <button className="Save ButtonCSS" onClick={SaveSignature}>
                    Save
                  </button>
                  <button className="Clear ButtonCSS" onClick={Clear}>
                    Clear
                  </button>
                  <button
                    onClick={(e) =>{ 
                      // setShow(!show)
                     setSigned(false)

                      dispatch(SetSignaturePops(false));
                    }
                      
                    }
                    className="Cancel ButtonCSS"
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignaturePopup;
